import { useMemo, useState } from 'react'
import { BsBank2, BsFillWalletFill } from 'react-icons/bs'
import { FaRegMoneyBillAlt } from 'react-icons/fa'
import { GiMoneyStack } from 'react-icons/gi'
import { HiDotsVertical } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { IBank, IFoodTable } from 'safe'
import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { RootState } from '../../redux/store'
import FoodTableIcon from '../../assets/images/foodTable.svg'

const FoodTableCard: React.FC<FoodTableCardProps> = ({
  table,
  fromSafeBox = false,
  onPressCardProp = () => null,
  banks = [],
  onEdit,
  onDelete,
  onWatch,
  onCreateOrder,
  // setFormAccountModal,
  // setEditingAccount,
}) => {
  const [modalDescription, setModalDescription] = useState<boolean>(false)
  const [visibleMenu, setVisibleMenu] = useState<boolean>(false)
  const [displayConfirm, setDisplayConfirm] = useState<boolean>(false)
  const [editModal, setEditModal] = useState<boolean>(false)
  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])
  const { user } = useSelector((state: RootState) => state.auth)


  const { addAlert } = useSnackBars()

  const onPressCard = () => {}

  const dispatch = useDispatch()

  const toggle = (): void => {
    setVisibleMenu((state) => !state)
  }

  const setVisible = async (wantedState: boolean) => {
    try {
      addAlert({
        message: 'Actualizando cuenta...',
        status: 'loading',
      })
      //   await dispatch(setAccountVisible(String(table.id), wantedState))
      addAlert({
        message: 'Visibilidad actualizada con éxito',
        status: 'success',
      })
    } catch (error: any) {
      addAlert({
        message:
          error.response.data.message ||
          'Error al modificar disponibilidad en cuenta',
        status: 'error',
      })
    } finally {
      toggle()
    }
  }

  const onCustomFilter = useMemo(() => {

    const options = [
      {
        title: 'Crear comanda',
        action: () => {
          onCreateOrder && onCreateOrder()
        },
        display: true,
      },
      {
        title: 'Ver',
        action: () => {
          onWatch && onWatch()
        },
        display: true,
      },
    
      {
        title: 'Editar Mesa',
        action: () => onEdit && onEdit(table),
        display: true,
      },
      {
        title: 'Eliminar',
        action: () => setDisplayConfirm(true),
        display: true,
      },
    ]

    if (user['custom:user_role'] === 'master') { 
      delete options[0]
    }

    if (user['custom:user_role'] === 'waiter') {
      delete options[2]
      delete options[3]
    }

    return options
   
  }, [user])
 

  return (
    <>
      <ModalViewWithTabs
        display={modalDescription}
        onClose={() => {
          setModalDescription(false)
        }}
        dataWithTabs={dataWithTabs}
      />

      <div className="2xl:w-96 w-80 shadow-lg rounded-lg p-4 mb-5 mr-5 text-xl flex justify-between relative dark:bg-black m-auto">
        <div
          className="w-80 cursor-pointer"
          onClick={() => onPressCardProp()}
          // style={{ opacity: account.accountVisible ? '1' : '0.4' }}
        >
          <div className="h-8 flex items-center">
            <div className="flex items-center truncate text-primary-600 font-medium">
              <div className="mr-4">
                <img src={FoodTableIcon} alt="foodTable" className="w-5 h-5" />
              </div>
              <div className="truncate text-sm max-h-10 dark:text-white">
                {table?.name}
              </div>
            </div>
          </div>

          <div>
            <div className="text-sm max-h-10 dark:text-white">
              {table?.description}
            </div>
          </div>
        </div>

        {!fromSafeBox && (
          <FloatingMenu
            onClose={() => {
              setVisibleMenu(false)
            }}
            visible={visibleMenu}
            options={{
              onCustomButtons: onCustomFilter,
            }}
          >
            <HiDotsVertical
              className="cursor-pointer text-gray-400"
              onClick={toggle}
            />
          </FloatingMenu>
        )}
      </div>

      <ModalConfirm
        title={'¿Está seguro que desea eliminar esta mesa?'}
        displayConfirmModal={displayConfirm}
        onConfirm={() => onDelete && onDelete(table.id)}
        onCancel={() => setDisplayConfirm(false)}
      ></ModalConfirm>
    </>
  )
}

interface FoodTableCardProps {
  table: IFoodTable
  fromSafeBox?: boolean
  onPressCardProp?: Function
  onEdit?: Function
  banks?: IBank[]
  onDelete?: Function
  onWatch?: Function
  onCreateOrder?: Function
}

export default FoodTableCard
